// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"228":"4de28112","306":"28f0f583","382":"929343ed","493":"dc02b587","972":"556fd724","978":"6b03dd35"}[chunkId] + ".css";
};